/* Keeps the cart's free gift in line with the cart value.
   Tiers come from snippets/free-gift-config.liquid via the script tag's data-gifts.

   The theme changes the cart from dozens of places, so instead of hooking each one
   this watches every cart write (fetch + XHR) and re-checks afterwards. Full page
   posts are covered by the check on page load. */
(function () {
  'use strict';

  // false: only the highest tier's gift is in the cart. true: every unlocked gift.
  var STACK_GIFTS = false;

  var script = document.currentScript;
  var tiers = String((script && script.getAttribute('data-gifts')) || '')
    .split(',')
    .map(function (entry) {
      var parts = entry.split(':');
      return { min: parseInt(parts[0], 10), variantId: parseInt(parts[1], 10) };
    })
    .filter(function (t) { return t.min > 0 && t.variantId > 0; })
    .sort(function (a, b) { return a.min - b.min; });

  if (!tiers.length || !window.fetch) return;

  var nativeFetch = window.fetch;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;
  var running = false;
  var queued = false;

  function isGift(variantId) {
    return tiers.some(function (t) { return t.variantId === variantId; });
  }

  // What the cart should hold for a given value, as { variantId: quantity }.
  function wantedGifts(value) {
    var unlocked = tiers.filter(function (t) { return value >= t.min; });
    var keep = STACK_GIFTS ? unlocked : unlocked.slice(-1);
    var wanted = {};
    tiers.forEach(function (t) { wanted[t.variantId] = 0; });
    keep.forEach(function (t) { wanted[t.variantId] = 1; });
    return wanted;
  }

  function neededUpdates(cart) {
    var value = cart.total_price;
    var current = {};
    (cart.items || []).forEach(function (line) {
      if (isGift(line.variant_id)) {
        current[line.variant_id] = (current[line.variant_id] || 0) + line.quantity;
        value -= line.final_line_price; // a gift never counts towards its own tier
      }
    });

    var wanted = wantedGifts(value);
    var updates = {};
    var changed = false;
    Object.keys(wanted).forEach(function (id) {
      if ((current[id] || 0) !== wanted[id]) {
        updates[id] = wanted[id];
        changed = true;
      }
    });
    return changed ? updates : null;
  }

  function showResult(cart) {
    document.querySelectorAll('.bigcounter').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    // The cart page is rendered by the server, so it has to reload to show the change.
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer();
  }

  function sync() {
    if (running) { queued = true; return; }
    running = true;

    // nativeFetch, so this function's own write doesn't trigger another check.
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = neededUpdates(cart);
        if (!updates) return;
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart update failed: ' + r.status);
          return r.json();
        }).then(showResult);
      })
      .catch(function (e) { console.error('[Kidbea:free-gift]', e); })
      .then(function () {
        running = false;
        if (queued) { queued = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 250);
  }

  window.fetch = function (input) {
    var url = String((input && input.url) || input || '');
    var result = nativeFetch.apply(this, arguments);
    if (CART_WRITE.test(url)) result.then(schedule, schedule);
    return result;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_WRITE.test(String(url))) this.addEventListener('loadend', schedule);
    return nativeOpen.apply(this, arguments);
  };

  schedule();
})();
